import { ExpenseResponse } from "../../models/ResponseModels/ExpenseResponse";
import { RecurringExpenseResponse } from "../../models/ResponseModels/RecurringExpenseResponse";
import { StatisticsBreakdownItem } from "../../models/ResponseModels/StatisticsSummaryResponse";
import { AppColors } from "../../constants/AppColors";

export const statisticsChartColors = [
  AppColors.primary,
  "#16a34a",
  "#f59e0b",
  "#7c3aed",
  "#dc2626",
  "#0891b2",
  "#64748b",
  "#84cc16",
];

export const formatMoney = (
  amount: number | string | null | undefined,
  currency = "",
) => {
  const numericAmount = Number(amount || 0);

  return `${numericAmount.toFixed(2)} ${currency}`.trim();
};

export const formatPercent = (amount: number | string | null | undefined) => {
  return `${Number(amount || 0).toFixed(1)}%`;
};

export const getExpenseLocation = (expense: ExpenseResponse) => {
  if (expense.unit?.name) {
    return expense.property?.name
      ? `${expense.property.name} · ${expense.unit.name}`
      : expense.unit.name;
  }

  if (expense.property?.name) {
    return expense.property.name;
  }

  return "General";
};

export const getRecurringExpenseLocation = (
  expense: RecurringExpenseResponse,
) => {
  if (expense.unit?.name) {
    return expense.property?.name
      ? `${expense.property.name} · ${expense.unit.name}`
      : expense.unit.name;
  }

  if (expense.property?.name) {
    return expense.property.name;
  }

  return "General";
};

export const getBreakdownTitle = (item: StatisticsBreakdownItem) => {
  return item.unit_name || item.property_name || item.month || "-";
};
